import { authenticatedProApiFetch } from "./pro-api.client";

export interface RewardRuleRequirement {
  moduleId: string;
  title: string;
  slug: string;
  heroImageUrl: string | null;
}

export interface RewardRuleRewardRole {
  roleId: string;
  name: string;
  label: string | null;
}

export interface RewardRuleRewardPermission {
  permissionId: string;
  name: string;
  description: string | null;
}

export interface RewardRule {
  id: string;
  name: string;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
  requirements: RewardRuleRequirement[];
  rewards: {
    roles: RewardRuleRewardRole[];
    permissions: RewardRuleRewardPermission[];
  };
}

export interface RewardRulePayload {
  name: string;
  enabled?: boolean;
  requirementModuleIds: string[];
  rewardRoleIds: string[];
  rewardPermissionIds: string[];
}

export interface RewardRuleRetroactiveResult {
  scanned: number;
  granted: number;
}

export async function fetchRewardRules(accessToken: string): Promise<RewardRule[]> {
  return authenticatedProApiFetch<RewardRule[]>("/certification-reward-rules", accessToken, {
    method: "GET",
  });
}

export async function createRewardRule(
  accessToken: string,
  payload: RewardRulePayload,
): Promise<RewardRule & { retroactive: RewardRuleRetroactiveResult }> {
  return authenticatedProApiFetch<RewardRule & { retroactive: RewardRuleRetroactiveResult }>(
    "/certification-reward-rules",
    accessToken,
    { method: "POST", body: JSON.stringify(payload) },
  );
}

export async function updateRewardRule(
  accessToken: string,
  ruleId: string,
  payload: Partial<RewardRulePayload>,
): Promise<RewardRule & { retroactive?: RewardRuleRetroactiveResult }> {
  return authenticatedProApiFetch<RewardRule & { retroactive?: RewardRuleRetroactiveResult }>(
    `/certification-reward-rules/${ruleId}`,
    accessToken,
    { method: "PATCH", body: JSON.stringify(payload) },
  );
}

export async function deleteRewardRule(accessToken: string, ruleId: string): Promise<void> {
  await authenticatedProApiFetch(`/certification-reward-rules/${ruleId}`, accessToken, {
    method: "DELETE",
  });
}
